










































import { shortTimeAgo } from '@/helpers/date-utils';
import { CampaignType, IEmail } from '@/store/types';
import { CAMPAIGN_TYPE, replaceMergeFields } from '@/store/shared';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'EmailPreview',
  props: {
    email: {
      type: Object as PropType<IEmail>,
    },
    previewEmail: {
      type: Boolean,
    },
    campaignType: {
      type: String as PropType<CampaignType>,
      default: CAMPAIGN_TYPE.DELINQUENCY,
    },
  },
  data() {
    return {
      shortTimeAgo,
      merge: {
        FIRST_NAME: 'Elizabeth',
        CARD_BRAND: 'VISA',
        LAST_4: '4242',
      },
    };
  },
  computed: {
    ...mapGetters(['orgBranding', 'hostedBillingPage']),
    subjectMerged(): string {
      return replaceMergeFields(this.email.subject, this.$data.merge);
    },
    previewTextMerged(): string {
      return replaceMergeFields(this.email.previewText, this.$data.merge);
    },
    emailContentMergeFieldsReplaced(): string {
      let content = this.email.content;
      const slug = this.campaignType === CAMPAIGN_TYPE.DELINQUENCY ? 'demo' : 'demo-reactivation';
      const ctaLink = this.hostedBillingPage ? `${this.hostedBillingPage}/${slug}` : undefined;
      content = replaceMergeFields(content, this.$data.merge, true, ctaLink);
      return content;
    },
  },
  methods: {},
});
